import React from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { getResourceTo } from 'react/utils/utils';

const formatValue = (value, capability, capabilityType) => {
  if (capability === 'speed') {
    const isMetric = Monet.Session.User.unitSystem !== 'NON_METRIC';
    const suffixKey = isMetric 
      ? 'Greenmile.UnitMetrics.kilometersPerHour'
      : 'Greenmile.UnitMetrics.milesPerHour';
    const suffix = Monet.I18n.getResourcesByKey(suffixKey);
    return `${value} ${suffix}`;
  }
  
  if (capabilityType === 'BOOLEAN') {
    const resourceKey = value 
      ? 'Greenmile.Telematic.valueBooleanTrue'
      : 'Greenmile.Telematic.valueBooleanFalse';
    return Monet.I18n.getResourcesByKey(resourceKey);
  }
  
  return value;
};

function Chart({ data, rangeSelectorSelected = 1 }) {
  const options = {
    chart: {
      reflow: true,
      height: '250px'
    },
    lang: {
      rangeSelectorZoom: getResourceTo('Greenmile.Telematic.Chart.zoom')
    },
    global: {
      useUTC: false
    },
    rangeSelector: {
      inputEnabled: false,
      allButtonsEnabled: true,
      buttonSpacing: 15,
      selected: rangeSelectorSelected,
      buttonTheme: {
        width: null
      },
      buttons: [
        {
          type: 'minute',
          count: 8,
          text: `8 ${getResourceTo('Greenmile.Telematic.Chart.zoomMinutes')}`
        },
        {
          type: 'hour',
          count: 1,
          text: `1 ${getResourceTo('Greenmile.Telematic.Chart.zoomHour')}`
        },
        {
          type: 'day',
          count: 1,
          text: `1 ${getResourceTo('Greenmile.Telematic.Chart.zoomDay')}`
        },
        {
          type: 'month',
          count: 1,
          text: `1 ${getResourceTo('Greenmile.Telematic.Chart.zoomMonth')}`
        },
        {
          type: 'year',
          count: 1,
          text: `1 ${getResourceTo('Greenmile.Telematic.Chart.zoomYear')}`
        },
        {
          type: 'all',
          count: 1,
          text: getResourceTo('Greenmile.Telematic.AllDataOnGraph')
        }
      ]
    },
    tooltip: {
      formatter() {
        let content = '';
        const { x, points } = this;
        const dateFormmated = Monet.Format.DateTime.formatToLocale(x);

        content += `<b style="font-size: 10pt">${dateFormmated}</b> <br/>`;

        points?.forEach((point) => {
          const {
            y,
            color,
            series: {
              name,
              yAxis: {
                options: {
                  custom: { capability, capabilityType }
                }
              }
            }
          } = point;
          
          const valueFormatted = formatValue(y, capability, capabilityType);

          content += `<span style="color:${color}">\u25CF</span>`;
          if (name) {
            content += `${name}:`;
          }
          content += ` <b>${valueFormatted}</b><br/>`;
        });

        return content;
      }
    },
    plotOptions: {
      series: {
        turboThreshold: 0,
        dataGrouping: {
          approximation: 'open'
        }
      }
    }
  };
  const chartOptions = {
    ...options,
    ...data
  };
  return (
    <HighchartsReact
      highcharts={Highcharts}
      constructorType="stockChart"
      options={chartOptions}
      immutable={true}
    />
  );
}
Chart.propTypes = {
  data: PropTypes.object.isRequired,
  rangeSelectorSelected: PropTypes.number
};

export default Chart;
